export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn } = useUserSession()

  if (!loggedIn.value) {
    // Simpan halaman yang tadi dituju supaya sesudah login user kembali ke
    // sana. Tanpa ini, buka /dashboard/4?customer_key=… → login → terlempar
    // ke beranda, dan di host salestial.iziapp.id beranda itu landing page
    // statis (bukan app) sehingga terlihat seperti keluar dari aplikasi.
    const tujuan = to.fullPath && to.fullPath !== '/' ? to.fullPath : ''
    return navigateTo(tujuan ? `/login?redirect=${encodeURIComponent(tujuan)}` : '/login')
  }
})
